'use client';

import { useRouter } from 'next/navigation';
import type { ModalKey } from '@/app/cc/_types/modal';

export function useOpenModal() {
  const router = useRouter();
  return (modalKey: ModalKey) => {
    const url = new URL(globalThis.window?.location.href ?? '');
    url.searchParams.set('modal', modalKey);
    router.push(`${url.pathname}?${url.searchParams.toString()}`, { scroll: false });
  };
}
